import React, { ComponentProps } from "react";

import { Controller, useFormContext } from "react-hook-form";

import { Select } from "@/components/forms/BaseForm/selects/Select";
import { generateTestId } from "@/util/testIds";

export interface FormSelectProps
  extends Omit<ComponentProps<typeof Select>, "value" | "onChange"> {
  name: string;
  classNamePrefix?: string;
}

export const FormSelect: React.FC<FormSelectProps> = ({ name, ...props }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <Select
          value={value}
          onChange={onChange}
          data-testid={generateTestId.form("select", name)}
          {...props}
        />
      )}
    />
  );
};
